import { render, staticRenderFns } from "./DisponibilidadeCardEditavel.vue?vue&type=template&id=37c31c1a&scoped=true&"
import script from "./DisponibilidadeCardEditavel.vue?vue&type=script&lang=js&"
export * from "./DisponibilidadeCardEditavel.vue?vue&type=script&lang=js&"
import style0 from "./DisponibilidadeCardEditavel.vue?vue&type=style&index=0&id=37c31c1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c31c1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VLayout,VRow,VTextField})
